import { render, staticRenderFns } from "./FilterTitleButton.vue?vue&type=template&id=00b7a4b2"
import script from "./FilterTitleButton.vue?vue&type=script&lang=js"
export * from "./FilterTitleButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports